export default __webpack_public_path__ + "static/media/shop-banner.bb443da3.jpeg";